<script setup lang="ts">
import { useI18n } from "@/app/composables/useI18n"

interface Props {
  show: boolean
  message: string
  confirmText?: string
  cancelText?: string
}

withDefaults(defineProps<Props>(), {
  confirmText: "Yes",
  cancelText: "No",
})

const emit = defineEmits<{
  (e: "confirmHandler", value: boolean): void
}>()

const { t } = useI18n()
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-confirmation">
      <div class="modal-container">
        <div class="modal-detail">
          <div class="close-btn" @click="() => emit('confirmHandler', false)">
            {{ t("close") }}
            <img src="/assets/images/close-modal-icon.svg" alt="">
          </div>

          <div class="modal-body">
            <div class="free-bet">
              <div class="free-award">
                {{ message }}
              </div>

              <div class="confirmation-actions">
                <button
                  class="btn btn-confirm"
                  @click="() => emit('confirmHandler', true)"
                >
                  {{ confirmText }}
                </button>
                <button
                  class="btn btn-cancel"
                  @click="() => emit('confirmHandler', false)"
                >
                  {{ cancelText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.modal-confirmation {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 30px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-detail {
  position: relative;
}
.modal-body {
  padding: 20px;
  background: var(--be-bg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  border-radius: 20px;
}
.close-btn {
  position: absolute;
  top: -32px;
  right: 3px;
  display: flex;
  gap: 0 5px;
  color: white;
  cursor: pointer;
  text-transform: capitalize;
}
.confirmation-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;

  .btn {
    flex: 1;
    background: var(--be-primary-btn);
    font-size: 14px;
    font-family: Poppins;
    border-radius: 5px;
    height: 41px;
    border: none;
    cursor: pointer;
    color: white;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }

    &.btn-cancel {
      background: var(--be-danger-btn, #f44336);
    }
  }
}
</style>
